(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ov25-configurator"] && !Shopify.designMode) return;
  try {
    function ov25OverlayFor(button) {
    var overlayId = button.getAttribute('aria-controls');
    return overlayId ? document.getElementById(overlayId) : null;
  }

  function ov25SetExpanded(button, expanded) {
    if (!button) return;
    var label = button.querySelector('[data-ov25-label]');
    var nextLabel = expanded ? button.getAttribute('data-label-close') : button.getAttribute('data-label-open');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (nextLabel) button.setAttribute('aria-label', nextLabel);
    if (label && nextLabel) label.textContent = nextLabel;
  }

  function ov25Open(button) {
    var overlay = ov25OverlayFor(button);
    var iframe = overlay && overlay.querySelector('iframe');
    if (!overlay || !iframe) return;

    if (!iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.getAttribute('data-src'));
    }

    overlay.hidden = false;
    ov25SetExpanded(button, true);
  }

  function ov25Close(overlay) {
    if (!overlay) return;
    overlay.hidden = true;
    ov25SetExpanded(document.querySelector('[aria-controls="' + overlay.id + '"]'), false);
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-ov25-open]');
    if (!openButton) return;

    event.preventDefault();
    event.stopPropagation();

    var overlay = ov25OverlayFor(openButton);
    if (overlay && !overlay.hidden) {
      ov25Close(overlay);
      return;
    }

    ov25Open(openButton);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ov25-overlay:not([hidden])').forEach(ov25Close);
  });

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var variantId = String(variant.id);
    document.querySelectorAll('[data-ov25-viewer]').forEach(function (viewer) {
      var urlsEl = document.getElementById(viewer.getAttribute('data-ov25-urls'));
      var iframe = viewer.querySelector('iframe');
      if (!urlsEl || !iframe) return;

      var urls;
      try {
        urls = JSON.parse(urlsEl.textContent);
      } catch (error) {
        return;
      }

      if (!Object.prototype.hasOwnProperty.call(urls, variantId)) return;

      var nextUrl = urls[variantId] || viewer.getAttribute('data-default-url');
      if (!nextUrl) return;

      iframe.setAttribute('data-src', nextUrl);
      if (iframe.getAttribute('src') && iframe.src !== nextUrl) iframe.src = nextUrl;
    });
  }, true);
  } catch(e) { console.error(e); }
})();

})();
